export default {};



// WEBPACK FOOTER //
// ./src/table_module/configs/use_table_options.js